import {
  StyleSheet,
} from 'react-native';

import {
  primaryFont700,
} from '../Common';

export default StyleSheet.create({
  section: {
    backgroundColor: '#FE9065',
    color: 'white',
    // marginTop: 8,
    paddingTop: 8,
    paddingLeft: 20,
    padding: 6,
    justifyContent: 'center',
    height: 32,
    fontSize: 16,
    fontFamily: primaryFont700,
    fontWeight: '700',
    lineHeight: 17,
  },
});
